var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.177544 9.78449L2.31246 12.2745L8.00445 6.58449L8.00445 19.7435L11.5575 19.7435L11.5575 6.22549L17.2575 12.2725L19.7435 9.78449L10.1385 0.17749L-0.177544 9.78449Z",
    fill: "#FD9543"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.566,
    height: 19.922,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.e56fbf73f2f77623f39f42e38c4b8dba.svg";
export { ForwardRef as ReactComponent };